import React from "react";

export const PortfolioHeader = () =>
    <h4>
        React portfolio site
    </h4>

export const PortfolioContent = () =>
    <div>
        <p>This portfolio site is a React single-page-application put together using CSS Grid Layout. It is currently hosted by Netlify.</p>

        <p>The contact form is connected to my contact-form server, which is hosted on Heroku.</p>

        <p>Please feel free to take a peek at the Github repo for the portfolio <a href="https://github.com/mel-lim/portfolio-react" target="_blank" rel="noreferrer noopener">here</a>. The back-end code for the contact form can be found in the Kit Collab repo <a href="https://github.com/mel-lim/listmaker-backend" target="_blank" rel="noreferrer noopener">here</a>.</p>
    </div>